import BaseComponent from './BaseComponent';
import Menu from './Menu';

export default class Header extends BaseComponent {
	constructor() {
		super();

		this.init();

		// Listeners
		document.addEventListener('leave', () => {
			this.menu.close();
		});

		document.addEventListener('update-header', () => {
			this.init();
		});
	}

	init() {
		// Elements
		this.elm = document.querySelector('[data-header]');
		this.menuButton = this.elm.querySelector('[data-menu-button]');

		this.menu = new Menu(this.elm.querySelector('[data-menu]'), this);

		this.menuButton.addEventListener('click', () => {
			this.menu.toggle();
		});
	}
}
